// Print labels at a stock size (100 x 150 mm and the like), one label per sheet.
//
// lib/print.js prints A4 pages. A label sheet is another size, and the size is the browser's @page rule, so it is set
// for the length of the print and taken out again. The labels are copied into the same #print-root the print
// stylesheet (index.css) shows on its own, each in a box of exactly the sheet's size.
const BLEED_MM = 0.4; // a hair under the sheet, so rounding never pushes a blank sheet in between two labels

/** `nodes` is one label element or several (each printed on its own sheet); the sheet is `widthMm` x `heightMm`. */
export function printLabels(nodes, { widthMm, heightMm }) {
  const list = (nodes instanceof Element ? [nodes] : Array.from(nodes || [])).filter(Boolean);
  const w = Number(widthMm);
  const h = Number(heightMm);
  if (!list.length || !(w > 0) || !(h > 0)) return;

  const size = document.createElement("style");
  size.textContent = `@page { size: ${w}mm ${h}mm; margin: 0; }`; // after index.css's A4 rule, so it wins
  const root = document.createElement("div");
  root.id = "print-root";
  root.style.cssText = "position:absolute;left:-10000px;top:0;";
  list.forEach((node, i) => {
    const sheet = document.createElement("div");
    const lastSheet = i === list.length - 1;
    sheet.style.cssText = `width:${w}mm;height:${h - BLEED_MM}mm;overflow:hidden;${lastSheet ? "" : "break-after:page;page-break-after:always;"}`;
    sheet.appendChild(node.cloneNode(true));
    root.appendChild(sheet);
  });
  document.head.appendChild(size);
  document.body.appendChild(root);

  const cleanup = () => {
    root.remove();
    size.remove();
    window.removeEventListener("afterprint", cleanup);
  };
  window.addEventListener("afterprint", cleanup);
  window.print();
}
